import { API_VERSION, SERVER } from '@/services';
import { request } from 'umi';

export function putAvatar(avatarID: string) {
  return request<boolean>(`/${SERVER.user}/${API_VERSION}/users/${avatarID}`, {
    method: 'PUT',
  });
}
